import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PREFERENCE_EDIT } from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import { allPreferencesSelector } from '../../../../property/propertySlice';
import { useSelector } from 'react-redux';

const PREFERENCE_TAB_LIST = ['Details', 'Items'];

const PreferenceView = (props) => {
  const { onViewToggle, onDrawerToggle, object, permissions } = props;
  const [tabValue, setTabValue] = useState(0);
  const [title, setTitle] = useState(object?.name);

  const prefs = useSelector(allPreferencesSelector);
  const current = prefs.find((p) => p.id === object.id) || object;

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const onOpenDrawer = (event) => {
    event.stopPropagation();
    onDrawerToggle(PREFERENCE_EDIT, true, current);
  };

  useEffect(() => {
    setTitle(current?.name);
  }, [current?.name]);

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-4'>
                <div className='details-label'>Name</div>
                <div className='details-value preview-breaks'>{current.name}</div>
              </div>
              <div className='col-md-8'>
                <div className='details-label'>Code</div>
                <div className='details-value'>{current.code || '---' || '---'}</div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-fluid'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>{current.description || '---'}</div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Preference Type</div>
                <div className='details-value'>
                  {current.allowMultipleSelection ? 'Choose all that apply' : 'Choose one'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              {current.customAttributes &&
                current.customAttributes.length > 0 &&
                current.customAttributes.map((item, index) => (
                  <div key={index} className='col-md-6 mb-2'>
                    <div className='details-label'>{item.key}</div>
                    <div className='details-value'>{item.value}</div>
                  </div>
                ))}
            </div>
          </div>
        )}

        {tabValue === 1 && (
          <div className='row mx-4 mt-3 overflow-auto h-100 accordion-div-housekeeping'>
            <div className='col-md-12'>
              <div className='details-label'>Items</div>
              <div className='details-value'>
                {current?.preferenceItems?.length > 0 ? current.preferenceItems.length : 'NA'}
              </div>
              <div className='col-md-12'>
                {current.preferenceItems?.map((item, i) => (
                  <div className='row mt-3' key={i}>
                    <div className='col-md-12 bg-info p-2'>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`panel-${i}-content`}
                          id={`panel-${i}-header`}
                        >
                          <div className='mt-1'>
                            <div>
                              <span className='details-label'>Item Name: </span>
                              <span className='details-value'>{item.name}</span>
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className='col-12 pe-3'>
                            <div className='row'>
                              <div>
                                <div className='details-label'>Item Code</div>
                                <div className='details-value'>{item.code || '---'}</div>
                              </div>
                            </div>
                            <div className='row mt-3'>
                              <div className='col-fluid'>
                                <div className='details-label'>Description</div>
                                <div className='details-value'>{item.description || '---'}</div>
                              </div>
                            </div>
                            <div className='row mt-3'>
                              <div className='col-fluid'>
                                <div className='details-label'>Status</div>
                                <div className='details-value'>
                                  {item.isActive ? 'Active' : 'Inactive'}
                                </div>
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <DetailViewLayout
      onClickEdit={onOpenDrawer}
      renderScreen={renderScreen}
      handleTabChange={handleTabChange}
      tabValue={tabValue}
      tabList={PREFERENCE_TAB_LIST}
      onViewToggle={onViewToggle}
      title={title}
      createdUserId={object.createdBy}
      isEditable={permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
      tabClass='col-md-6'
    />
  );
};

export default PreferenceView;
